// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAkwgEPw1f41X-Pq6rgm_Jk96xJT3MP9O4",
    authDomain: "golf-league-tools.firebaseapp.com",
    databaseURL: "https://golf-league-tools-default-rtdb.firebaseio.com",
    projectId: "golf-league-tools",
    storageBucket: "golf-league-tools.firebasestorage.app",
    messagingSenderId: "1019715180704",
    appId: "1:1019715180704:web:ced8e1c1ee88893a8091c5",
    measurementId: "G-JP7VRGNGX4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const database = getDatabase(app);
const firestore = getFirestore(app);

export {auth, database, analytics, firestore};